import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import WhatWeDo from './components/WhatWeDo';
import WhyPartnerWithUs from './components/WhyPartnerWithUs';
import Tagline from './components/Tagline';
import Mission from './components/Mission';
import Vision from './components/Vision';
import GetInTouch from './components/GetInTouch';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WhatWeDo />
      <WhyPartnerWithUs />
      <Tagline />
      <Mission />
      <Vision />
      <GetInTouch />
      <Footer />
    </div>
  );
}

export default App;

